<template>
  <div class="koc-block koc-auth-login-block">
    <div
      v-if="state.showReset"
      class="reset-block"
    >
      <div class="koc-row right">
        <a @click.stop="state.showReset = false; state.reset = null;">
          <font-awesome-icon
            :icon="['fa', 'rectangle-xmark']"
            size="2x"
            class="koc-close-icon"
          />
        </a>
      </div>
      <div
        v-if="!resetMessage"
        class="koc-row"
      >
        <p class="reset-instructions">
          Submit your email address below and we will email you with a link to reset your password.
        </p>
      </div>
      <div class="koc-full">
        <form-input-component
          name="reset"
          type="text"
          label="Email Address"
          @update="state.update"
          @keyup.enter="resetOnEnter"
        />
      </div>
      <div
        v-if="state.resetMessage"
        class="reset-response-container"
      >
        {{ state.resetMessage }}
      </div>
      <div
        v-else
        class="koc-submit"
      >
        <button
          class="koc-button koc-ripple"
          :disabled="!state.validReset"
          @click="resetEmail"
        >
          Reset Password
        </button>
      </div>
    </div>

    <div
      v-else
      class="login-block"
    >
      <div class="koc-full">
        <form-input-component
          name="username"
          type="text"
          label="Username or Email"
          @update="state.update"
          @keyup.enter="loginOnEnter"
        />
      </div>
      <div class="koc-full">
        <form-input-component
          name="password"
          type="password"
          label="Password"
          @update="state.update"
          @keyup.enter="loginOnEnter"
        />
      </div>
      <div class="koc-submit">
        <button
          class="koc-button koc-ripple"
          :disabled="!state.canSubmit"
          @click="login"
        >
          Log In
        </button>
      </div>
      <div class="koc-row forgot-link-container">
        <a
          class="forgot-link koc-title"
          @click="state.showReset = true"
        >Forgot Your Password?</a>
      </div>
    </div>
  </div>
</template>

<script src="./login.js"></script>
<style lang="scss" scoped src="./login.scss"></style>
